import React, { FC } from 'react';
import { Marker } from 'react-leaflet';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import { MtsBadge } from '@mts-ds/components-react';
import Typography from '../../../components_/Typography';
import MarkerTooltip from '../../Main/Map/components/MarkerTooltip';
import moment from 'moment';
import { divIcon } from 'leaflet';
import { renderToString } from 'react-dom/server';
import { ReactComponent as StartMarker } from '../../../assets_/icons/startMarker.svg';
import { ReactComponent as FinishMarker } from '../../../assets_/icons/finishMarker.svg';
import { ReactComponent as NeutralMarker } from '../../../assets_/icons/neutralMarker.svg';
import { validateAndCreatePosition } from '../../../utils/validateCoords';

const useStyles = makeStyles(() => ({
  time: {
    paddingTop: '10px',
    paddingBottom: '10px'
  }
}));

interface IProps {
  points: any;
}

const StartAndFinishMarker: FC<IProps> = ({ points }) => {
  const classes = useStyles();
  const iconStart = divIcon({
    className: undefined,
    iconSize: undefined,
    iconAnchor: [15, 33],
    html: renderToString(<StartMarker />)
  });

  const iconFinish = divIcon({
    className: undefined,
    iconSize: undefined,
    iconAnchor: [15, 33],
    html: renderToString(<FinishMarker />)
  });

  const iconNeutral = divIcon({
    className: undefined,
    iconSize: undefined,
    iconAnchor: [15, 33],
    html: renderToString(<NeutralMarker />)
  });
  const singlePos = points.length >= 1
    ? validateAndCreatePosition(points[0].lat, points[0].lon, undefined, undefined, true)
    : null;
  const finishPos = points.length > 1
    ? validateAndCreatePosition(
        points[points.length - 1].lat,
        points[points.length - 1].lon,
        undefined,
        undefined,
        true
      )
    : null;
  return points.length === 1 ? (
    <>
      {singlePos && (
        <Marker
          position={{ lat: singlePos[0], lng: singlePos[1] }}
          icon={iconNeutral}
          noRemove
          key={'single'}
        >
        <MarkerTooltip>
          <Grid>
            <Typography className={classes.time} variant="p2Bold">{`${moment(points[0].time).format(
              'L HLTS'
            )}`}</Typography>
            <Typography variant="p3Regular">{`Широта ${points[0].lat}`}</Typography>
            <Typography variant="p3Regular">{`Долгота ${points[0].lon}`}</Typography>
            <Typography variant="p3Regular">{`Высота ${
              points[0].alt ? points[0].alt : '-'
            }`}</Typography>
          </Grid>
        </MarkerTooltip>
      </Marker>
      )}
    </>
  ) : (
    <>
      {singlePos && (
        <Marker
          position={{ lat: singlePos[0], lng: singlePos[1] }}
          icon={iconStart}
          noRemove
          key={'start'}
        >
        <MarkerTooltip>
          <Grid>
            <MtsBadge size="s">Старт</MtsBadge>
            <Typography className={classes.time} variant="p2Bold">{`${moment(points[0].time).format(
              'L HLTS'
            )}`}</Typography>
            <Typography variant="p3Regular">{`Широта ${points[0].lat}`}</Typography>
            <Typography variant="p3Regular">{`Долгота ${points[0].lon}`}</Typography>
            <Typography variant="p3Regular">{`Высота ${
              points[0].alt ? points[0].alt : '-'
            }`}</Typography>
          </Grid>
        </MarkerTooltip>
      </Marker>
      )}
      {finishPos && (
        <Marker
          position={{ lat: finishPos[0], lng: finishPos[1] }}
          icon={iconFinish}
          noRemove
          key={'finish'}
        >
        <MarkerTooltip>
          <Grid>
            <MtsBadge size="s">Финиш</MtsBadge>
            <Typography className={classes.time} variant="p2Bold">{`${moment(
              points[points.length - 1].time
            ).format('L HLTS')}`}</Typography>
            <Typography variant="p3Regular">{`Широта ${points[points.length - 1].lat}`}</Typography>
            <Typography variant="p3Regular">{`Долгота ${
              points[points.length - 1].lon
            }`}</Typography>
            <Typography variant="p3Regular">{`Высота ${
              points[points.length - 1].alt ? points[points.length - 1].alt : '-'
            }`}</Typography>
          </Grid>
        </MarkerTooltip>
      </Marker>
      )}
    </>
  );
};

export default StartAndFinishMarker;
